import { cx } from '@emotion/css';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';
import React, { memo } from 'react';
import { ix } from '../../../../../../utils/ix';
import { DEFAULT_OPERATOR } from '../../LightweightFilterMenu.constants';
import { useStyles } from './ChipContent.styles';
import { getValueToDisplay } from './ChipContent.utils';
export const ChipContent = memo(({ className, onRemove, isOpen, fieldName, id, operator, values, options, onChange, label }) => {
    const classes = useStyles();
    const handleClearClick = (event) => {
        onChange([], DEFAULT_OPERATOR, fieldName);
        event.stopPropagation();
    };
    const handleRemoveClick = (event) => {
        onRemove === null || onRemove === void 0 ? void 0 : onRemove(fieldName);
        event.stopPropagation();
    };
    const getOperatorText = () => {
        if (operator !== DEFAULT_OPERATOR && values.length > 0) {
            return (React.createElement("span", { id: ix(id, 'operator'), className: classes.chipContentOperator }, operator));
        }
        return null;
    };
    const getValuesText = () => {
        const valuesNumber = values.length;
        if (valuesNumber > 0) {
            const valueToDisplay = getValueToDisplay(options, values);
            return (React.createElement("span", { id: ix(id, 'value'), className: classes.chipContentValues }, valuesNumber > 1 ? `${valueToDisplay} +${valuesNumber - 1}` : valueToDisplay));
        }
        return React.createElement("span", { id: ix(id, 'value') }, "All");
    };
    const getChipIcon = () => {
        if (values.length > 0) {
            return React.createElement(ClearIcon, { id: ix(id, 'clear'), className: classes.icon, fontSize: "small", onClick: handleClearClick });
        }
        if (onRemove) {
            return React.createElement(ClearIcon, { id: ix(id, 'remove'), className: classes.icon, fontSize: "small", onClick: handleRemoveClick });
        }
        return isOpen ? (React.createElement(ExpandLessIcon, { fontSize: "small", className: classes.icon })) : (React.createElement(ExpandMoreIcon, { fontSize: "small", className: classes.icon }));
    };
    return (React.createElement(Box, { className: cx(className, classes.chipContent) },
        React.createElement("span", { id: ix(id, 'field-name'), className: classes.chipContentLabel }, label),
        getOperatorText(),
        getValuesText(),
        getChipIcon()));
});
//# sourceMappingURL=ChipContent.js.map